<template>
  <v-container grid-list-md text-xs-center>
    <connection-manager
      ref="connectionManager"
      v-model="connecting"
    ></connection-manager>
    <v-layout row wrap>
      <v-flex xs6>
        <v-text-field
          label="Urgent Cost per KM"
          v-model="costingVariables.URGENT_COST_PER_KM"
          required
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          label="Non-Urgent Cost per KM"
          v-model="costingVariables.NON_URGENT_COST_PER_KM"
          required
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs6>
        <v-text-field
          label="Errand Cost per KM"
          v-model="costingVariables.ERRAND_COST_PER_KM"
          required
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          label="Urgent Cost per MIN"
          v-model="costingVariables.URGENT_COST_PER_MIN"
          required
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs6>
        <v-text-field
          label="Non-Urgent Cost per MIN"
          v-model="costingVariables.NON_URGENT_COST_PER_MIN"
          required
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          label="Errand Cost per MIN"
          v-model="costingVariables.ERRAND_COST_PER_MIN"
          required
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs6>
        <v-text-field
          label="Urgent Base Cost"
          v-model="costingVariables.URGENT_BASE_COST"
          required
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          label="Non-Urgent Base Cost"
          v-model="costingVariables.NON_URGENT_BASE_COST"
          required
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs6>
        <v-text-field
          label="Errand Base Cost"
          v-model="costingVariables.URGENT_MIN_COST"
          required
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          label="Non-Urgent Min Cost"
          v-model="costingVariables.NON_URGENT_MIN_COST"
          required
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs6>
        <v-text-field
          label="Profit"
          v-model="costingVariables.PROFIT"
          required
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          label="VAT"
          v-model="costingVariables.VAT"
          required
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs6>
        <v-text-field
          label="Stops Cost"
          v-model="costingVariables.STOPS_COST"
          required
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          label="Urgent Profit"
          v-model="costingVariables.URGENT_PROFIT"
          required
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs6>
        <v-text-field
          label="Non-Urgent Profit"
          v-model="costingVariables.NON_URGENT_PROFIT"
          required
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          label="Cost per 5 KM"
          v-model="costingVariables.COST_PER_5_KM"
          required
          :rules="[rules.required]"
        >
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-btn
      color="primary"
      :loading="connecting"
      :disabled="connecting || !valid"
      @click.native="submit"
    >
      Update
    </v-btn>
  </v-container>
</template>

<script>
import ConnectionManager from './ConnectionManager'
export default {
  components: {
    ConnectionManager
  },
  data() {
    return {
      costingVariables: {
        URGENT_COST_PER_KM: null,
        NON_URGENT_COST_PER_KM: null,
        ERRAND_COST_PER_KM: null,
        URGENT_COST_PER_MIN: null,
        NON_URGENT_COST_PER_MIN: null,
        ERRAND_COST_PER_MIN: null,
        URGENT_BASE_COST: null,
        NON_URGENT_BASE_COST: null,
        ERRAND_BASE_COST: null,
        URGENT_MIN_COST: null,
        NON_URGENT_MIN_COST: null,
        PROFIT: null,
        VAT: null,
        STOPS_COST: null,
        URGENT_PROFIT: null,
        NON_URGENT_PROFIT: null,
        COST_PER_5_KM: null
      },
      urgentCostPerKm: 0,
      nonUrgentCostPerKm: 0,
      connecting: false,
      rules: {
        required: value => !!value || 'Required.'
      }
    }
  },
  computed: {
    valid() {
      return (
        this.costingVariables.URGENT_BASE_COST &&
        this.costingVariables.URGENT_COST_PER_KM &&
        this.costingVariables.NON_URGENT_COST_PER_KM &&
        this.costingVariables.ERRAND_COST_PER_KM &&
        this.costingVariables.URGENT_COST_PER_MIN &&
        this.costingVariables.NON_URGENT_COST_PER_MIN &&
        this.costingVariables.ERRAND_COST_PER_MIN &&
        this.costingVariables.URGENT_BASE_COST &&
        this.costingVariables.NON_URGENT_BASE_COST &&
        this.costingVariables.ERRAND_BASE_COST &&
        this.costingVariables.URGENT_MIN_COST &&
        this.costingVariables.NON_URGENT_MIN_COST &&
        this.costingVariables.PROFIT &&
        this.costingVariables.VAT &&
        this.costingVariables.STOPS_COST &&
        this.costingVariables.URGENT_PROFIT &&
        this.costingVariables.NON_URGENT_PROFIT &&
        this.costingVariables.COST_PER_5_KM
      )
    }
  },
  methods: {
    submit() {
      let that = this
      this.$refs.connectionManager.patch(
        '/costVariables',
        {
          onSuccess(response) {
            that.$notify({
              group: 'all',
              title: 'Costing variables updated',
              text: 'All the costing variables have been updated!'
            })
            // that.courierOptions = that.courierOptions.concat(response.data.data)
          }
        },
        {
          URGENT_COST_PER_KM: this.costingVariables.URGENT_COST_PER_KM,
          NON_URGENT_COST_PER_KM: this.costingVariables.NON_URGENT_COST_PER_KM,
          ERRAND_COST_PER_KM: this.costingVariables.ERRAND_COST_PER_KM,
          URGENT_COST_PER_MIN: this.costingVariables.URGENT_COST_PER_MIN,
          NON_URGENT_COST_PER_MIN: this.costingVariables
            .NON_URGENT_COST_PER_MIN,
          ERRAND_COST_PER_MIN: this.costingVariables.ERRAND_COST_PER_MIN,
          URGENT_BASE_COST: this.costingVariables.URGENT_BASE_COST,
          NON_URGENT_BASE_COST: this.costingVariables.NON_URGENT_BASE_COST,
          URGENT_MIN_COST: this.costingVariables.URGENT_MIN_COST,
          NON_URGENT_MIN_COST: this.costingVariables.NON_URGENT_MIN_COST,
          PROFIT: this.costingVariables.PROFIT,
          VAT: this.costingVariables.VAT,
          STOPS_COST: this.costingVariables.STOPS_COST,
          URGENT_PROFIT: this.costingVariables.URGENT_PROFIT,
          NON_URGENT_PROFIT: this.costingVariables.NON_URGENT_PROFIT,
          COST_PER_5_KM: this.costingVariables.COST_PER_5_KM
        }
      )
    },
    fetchCostingVariables() {
      let that = this
      this.$refs.connectionManager.get(
        '/courierOptions',
        {
          onSuccess(response) {
            that.$app.log(response.data.data)
            that.$app.log(response.data.variables)
            that.costingVariables = response.data.costVariables
            // that.courierOptions = that.courierOptions.concat(response.data.data)
            that.step = 2
          }
        },
        { withCostVariables: true }
      )
    }
  },
  mounted() {
    this.fetchCostingVariables()
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/CostingVariables.vue